import { parseActiveExchangesFromKeys } from "utils/parseActiveExchangesFromKeys";
import NoWalletsWarning from "componentsCustom/NoWalletsWarning";
import { useSelector } from "react-redux";
import { STATUS } from "constants/fetchStatus";

export default function WalletsAddedGuard(props) {
    const activeExchanges = parseActiveExchangesFromKeys()
    const keysStatus = useSelector(state => state.keys.status)
    return (keysStatus === STATUS.LOADING || keysStatus === STATUS.PENDING || activeExchanges.length) ? props.children : <NoWalletsWarning />
}